import { render, staticRenderFns } from "./transferDeposit.vue?vue&type=template&id=286be37e"
import script from "./transferDeposit.ts?vue&type=script&lang=js&external"
export * from "./transferDeposit.ts?vue&type=script&lang=js&external"
import style0 from "./transferDeposit.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports